import { dom, format } from 'react-redux-app/lib/modules/core/utils';

import ApiClient, { apiClient } from './ApiClient';

import { getWebmasterId } from '../../auth/selectors';
import { getCurrentSiteId } from '../../site/selectors';


const errorParamsFormatterMap = {
  maxFileSize: format.humanReadableSize,
  allowedMediaTypes: format.humanReadableFileTypes,
};

class ApiClientHelper {
  constructor(apiClientInstance) {
    this.reduxStore = null;
    // Note: a hack [Issue #23847]
    this.isWindowUnloading = false;

    if (dom.isBrowser()) {
      window.addEventListener(
        'beforeunload',
        () => {
          this.isWindowUnloading = true;
        }
      );
    }

    ApiClient.getMethods().forEach(method => {
      this[method] = (path, defaultParams, ...rest) => {
        const defaultHeaders = {};
        const { getState } = this.reduxStore;

        const webmasterId = getWebmasterId(getState());
        if (webmasterId) {
          defaultHeaders['X-webmasterId'] = webmasterId;
        }

        const siteId = getCurrentSiteId(getState());
        if (siteId) {
          defaultHeaders['X-siteId'] = siteId;
        }

        const params = { ...(defaultParams || {}) };

        params.headers = {
          ...defaultHeaders,
          ...(params.headers || {}),
        };

        if (this.isWindowUnloading) {
          return new Promise(() => {});
        }

        return new Promise((resolve, reject) => {
          apiClientInstance[method](path, params, ...rest)
            .then(
              result => {
                if (this.isWindowUnloading) {
                  return;
                }

                resolve(result);
              },
              error => {
                if (this.isWindowUnloading) {
                  return;
                }

                reject(ApiClientHelper.formatRequestErrorParams(error));
              }
            );
        });
      };
    });
  }

  setReduxStore(reduxStore) {
    this.reduxStore = reduxStore;
  }

  static formatRequestErrorParams({ globalErrors, fieldErrors }) {
    const result = {};

    if (globalErrors) {
      result.globalErrors = ApiClientHelper.formatErrorParams(globalErrors);
    }
    if (fieldErrors) {
      result.fieldErrors = ApiClientHelper.formatErrorParams(fieldErrors);
    }

    return result;
  }

  static formatErrorParams(errors) {
    return errors.map(error => {
      const { params } = error;
      if (!params) {
        return error;
      }

      const formattedParams = {};
      Object.keys(params).forEach(paramName => {
        formattedParams[paramName] = typeof errorParamsFormatterMap[paramName] === 'function'
          ? errorParamsFormatterMap[paramName](params[paramName])
          : params[paramName];
      });

      return { ...error, params: formattedParams };
    });
  }
}

export default ApiClientHelper;

export const apiClientHelper = new ApiClientHelper(apiClient);
